<script setup lang="ts">
import type { LeaderboardEntry } from '~/components/leaderboard/LeaderboardTable.vue'

// The homepage is prerendered, so fetch client-side only to keep the board fresh
const { data, pending } = useAsyncData(
  'home-leaderboard-teaser',
  () => $fetch<{ entries: LeaderboardEntry[] }>('/api/leaderboard', {
    query: { period: 'weekly' }
  }),
  { server: false, lazy: true }
)

const topEntries = computed(() => (data.value?.entries ?? []).slice(0, 3))
</script>

<template>
  <div class="mx-auto flex w-full max-w-xl flex-col gap-6">
    <!-- The fetch is client-only, so hydration would compare a server-rendered
    empty state against client skeletons. ClientOnly keeps both sides in sync. -->
    <ClientOnly>
      <LeaderboardTable
        :entries="topEntries"
        :loading="pending"
        compact
        hide-count
      />
      <template #fallback>
        <LeaderboardTable
          :entries="[]"
          loading
          compact
        />
      </template>
    </ClientOnly>

    <div class="flex justify-center">
      <UButton
        label="View full leaderboard"
        trailing-icon="i-lucide-arrow-right"
        color="neutral"
        variant="outline"
        to="/leaderboard"
      />
    </div>
  </div>
</template>
